import React from 'react'

const Spinner = require('../../assets/icons/ui/loader.gif')

const ExportInProgress = () => {
  return (
    <>
      <div className="export-loading-spinner">
        <img src={Spinner} className="export-spinner-alignment" data-test="export-spinner-alignment" alt="Loading Icon" tabIndex="0"/>
        <div className="export-loading-message" data-test="export-loading-message" aria-labelledby="export-progress">
          <span id="export-progress" tabIndex="0">Export In Progress..</span>
        </div>
        <div className="export-wait" data-test="export-wait" aria-labelledby="export-wait-text">
          <span id="export-wait-text" tabIndex="0">
            Please wait while we prepare your file for export
          </span>
        </div>
      </div>
    </>
  )
}

export default ExportInProgress